import React, { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, Layout, Typography } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import "./Auth.css";
import Title from "antd/es/typography/Title";
import { useAuth } from "./AuthProvider";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    setErrMsg("");
    setIsLoading(true);

    // TODO: check si le mail est bien formaté

    const res = await login({
      email: values.username,
      password: values.password,
    });

    if (res.error) {
      setErrMsg(res.msg);
      setIsLoading(false);
    } else {
      console.log(res.data);
      setTimeout(() => {
        setIsLoading(false);
        navigate("/", { replace: true });
      }, 1000);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Header>Nabook</Header>
      <Content
        style={{
          display: "flex",
          margin: "16px 100px",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Title
          level={1}
          style={{
            marginBottom: 35,
          }}
        >
          Se connecter
        </Title>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          style={{
            width: 300,
            maxWidth: 300,
          }}
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: "Mail nécessaire", type: "email" },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Mot de passe nécessaire" }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          {/* <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
          </Form.Item> */}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={isLoading}
            >
              Connexion
            </Button>
          </Form.Item>
          {errMsg.length > 0 ? <Text type="danger">{errMsg}</Text> : ""}
        </Form>
      </Content>
    </Layout>
  );
};

export default Login;
